import React from 'react';
import { CurrencySelector } from '../../_components';
import { CompanyInfo } from './CompanyInfo';
import { currencyTypeConstants } from '../../_constants'
import { currencyServices , transactionService } from '../../_services'
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';

export class DepositForm extends React.Component {

    constructor(props){
        super(props); 

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event){
        event.preventDefault();
        
        const {blockChainTxId , currency , amount , file , currencyType , isHWGCash , authentication } = this.props; 

        if(currencyType === currencyTypeConstants.CURRENCYTYPE_CASH){
            //make sure file is not empty for cash transfer 
            if(!file){
                
                Alert.error(`Please upload proof of transaction slip to proceed`, {
                    position: 'bottom-right' , 
                    effect : 'flip'
                });

                return false;
            }
        }
        
        let formBody = {
            blockChainTxId : blockChainTxId, 
            currency : currency , 
            amount : amount , 
            memberId : authentication.user.id
        }; 

        this.setState({
            disableSubmit : true
        });

        transactionService.createMemberDeposit(formBody , file);
    }

    render (){
        const { handleCurrencyDropdown , handleChange , handleUploadFile
            , currencies , currency , currencyType , settings ,
            amount , filename , image , disableSubmit , blockChainTxId  } = this.props ; 

        return (
            
            <form onSubmit={this.handleSubmit} className="default-form is-clearfix">
                <h4>Deposit Form</h4>

                <div className="has-instruction">
                    1. Select Asset and fill up amount
                </div>

                <div className="field is-horizontal m-t-md">
                    <div className="field-label is-small">
                        <label className="label">Asset</label>
                    </div>
                    <div className="field-body">
                        <CurrencySelector currencies={currencies} currency={currency} 
                                        handleChange={handleCurrencyDropdown} defaultText='Select Asset'/>
                        
                    </div>
                </div>

                <div className="field is-horizontal">
                    <div className="field-label is-small">
                        <label className="label">Quantity</label>
                    </div>
                    <div className="field-body">
                        <input className="input is-small" onChange={handleChange} name="amount" value={amount} type="text" placeholder="Quantity to deposit" 
                            required
                        />
                    </div>
                </div>

                <div className="has-instruction">
                    2. Bank / Wallet Details
                </div>

                <div className='form-info m-b-md'>
                    <CompanyInfo settings = {settings} currencyType={currencyType} currency={currency}/>
                </div>
                
                {
                    (currencyType === currencyTypeConstants.CURRENCYTYPE_DIGITAL_ASSET) &&    
                    <div className="field is-horizontal">
                        <div className="field-label is-small ">
                            <label className="label">Transaction ID</label>
                        </div>
                        <div className="field-body">
                            <input className="input is-small" value={blockChainTxId} name="blockChainTxId" onChange={handleChange} type="text" placeholder={`${currency} Transaction Reference`} />
                        </div>
                    </div>
                }
                
                <div className="has-instruction">
                    3. Proof of Transaction or fill in coin transfer reference
                </div>

                <div className="field is-horizontal">
                    <div className="field-label is-small">
                        <label className="label">Upload Slip</label>
                    </div>
                    <div className="field-body">
                        <div className="file has-name is-right">
                            <label className="file-label">
                                <input onChange={handleUploadFile} className="file-input" type="file" name="filename" />
                                <span className="file-cta ">
                                    <span className="file-icon">
                                        <i className="fas fa-upload"></i>
                                    </span>
                                    <span className="file-label">
                                        Choose a file…
                                    </span>
                                </span>
                                <span className="file-name">
                                    {filename}
                                </span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="field is-horizontal">
                    <div className="field-label is-small">
                        <label className="label"></label>
                    </div>
                    <div className="field-body">
                        <img src={image} className="holder-upload-image"/>
                    </div>
                </div>
                
                <div className="control m-t-lg is-pulled-right">
                    <input type="submit" disabled={disableSubmit} className="button button-submit" value="Deposit"/>
                </div>
            </form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Views/DepositPage/DepositForm.jsx